import config from './index.js'

export const ACCESS_TOKEN_URL = config.BACKEND_URL + '/api/v1/github/auth/accesstoken';
export const INBOX_CAPABILITY_URL = config.BACKEND_URL + '/api/v1/flow/capabilities/inbox';
export const OUTBOX_CAPABILITY_URL = config.BACKEND_URL + '/api/v1/flow/capabilities/outbox';